import { InjectionToken } from '@angular/core';
import { Environment } from '@gea/digital-ui-lib';

export const BASE_URL = new InjectionToken<string>('baseUrl');
export const HRT_BASE_URL = new InjectionToken<string>('hrtBaseUrl');
export const SUBSCRIPTION_KEY = new InjectionToken<string>('subscriptionKey');
export const HRT_FAULT_DB_BASE_URL = new InjectionToken<string>('hrtFaultDatabaseBaseUrl');
export const HRT_FAULT_DB_SUBSCRIPTION_KEY = new InjectionToken<string>('hrtFaultDatabaseSubscriptionKey');
export const HRT_SUBSCRIPTION_KEY = new InjectionToken<string>('hrtSubscriptionKey');
export const STORAGE_URL = new InjectionToken<string>('storageURL');
export const ICON_PATH = new InjectionToken<string>('iconPath');
export const ENVIRONMENT_CONFIG = new InjectionToken<Environment>('Environment_Configuration');
export const PACKAGE_VERSION = new InjectionToken<Environment>('packageVersion');
